import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { RouteComponent } from '@app/route/route.component';
import { UserService } from '@app/service/user-service/user.service';
import { HeaderService } from '@app/service/header/header.service';
import { StateService, ZaverProduct } from '@app/service/state/state.service';
import { SelectorItem } from '@app/component/selector/selector.component';
import { ValuePipe } from '@app/shared/pipe/value.pipe';

@Component({
  selector: 'confirm_tokenized_onboarding_invoice',
  templateUrl: './confirm_tokenized_onboarding_invoice.component.html',
  styleUrls: [
    '../../page-shared.css',
    './confirm_tokenized_onboarding_invoice.component.scss',
  ],
})
export class SeConfirmTokenizedOnboardingComponent
  extends RouteComponent
  implements OnInit
{
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected userService: UserService,
    private valuePipe: ValuePipe
  ) {
    super(router, route, stateService, headerService);
  }
  selectorItems: SelectorItem[] = null;
  modalActive: boolean = false;
  selectedItem: SelectorItem;
  ZAVERPRODUCT = ZaverProduct;

  async ngOnInit(): Promise<void> {
    this.selectorItems = [
      ...(this.state.zaverProduct ===
      ZaverProduct.SE_TOKENIZED_ONBOARDING_CREDIT_WITH_PAYMENT
        ? [
            {
              tab: 'Ditt köp',
              title: 'Sammanfattning',
              descriptions: [
                { text: this.state.paymentInformation.description },
              ],
              lineItems: this.state.paymentInformation?.lineItems,
              totalValue: `Totalbelopp inkl. moms: ${this.valuePipe.transform(
                this.state.totalCheckoutValue
              )}`,
            },
          ]
        : []),
      {
        tab: 'Betalningsvillkor',
        title: 'Medgivande till betalning via Autogiro',
        links: [
          {
            text: 'Kreditavtal',
            onClick: () => {
              window.open(
                'https://cdn.zaver.com/SE/docs/autogiro-terms-standard.pdf',
                '_blank'
              );
            },
          },
        ],
      },
    ];
  }

  async handleCtaClick() {
    try {
      await this.userService.confirmTokenizedOnboardingInvoice();
      await this.navigate();
    } catch (error) {
      console.log(error);
    }
  }

  toggleModal(): void {
    this.modalActive = !this.modalActive;
  }

  showPurchaseInformation(): void {
    this.selectedItem = this.selectorItems[0];
    this.toggleModal();
  }

  showTerms(): void {
    // terms is the last item in the array
    this.selectedItem = this.selectorItems[this.selectorItems.length - 1];
    this.toggleModal();
  }
}
